/* eslint-disable-next-line no-use-before-define */
/* eslint-disable no-plusplus */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  setIsLoading,
  getProductBanners,
  setProductBanners,
  getProductGroups,
  setProductGroups,
  getProducts,
  setProducts,
  setPreInvoices,
  savePreInvoiceRequest,
  setMyOrders,
  getMyOrders,
  toggleFavouriteRequest,
  setAllFavouriteProducts,
  getAllFavouriteRequest,
  saveUserAddress,
} from './posSlice';
import mobilePosService from '../../services/pos/mobilePosService';
import PreInvoicesService from '../../services/pos/PreInvoicesService';
import { toast } from 'react-toastify';
import { clearCart } from '../addCart/cartSlice';

function* handleGetProductBanners(action) {
  try {
    const data = yield call(mobilePosService.getProductBanners, action.payload);
    const finalData = data?.items || data || [];

    yield put(setProductBanners(finalData));
  } catch (e) {
    console.log('Saga Error:', e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchGetProductBanners() {
  yield takeLatest(getProductBanners.type, handleGetProductBanners);
}

function* handleGetProductGroups() {
  try {
    const data = yield call(mobilePosService.getProductGroups);
    yield put(setProductGroups(data));
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchGetProductGroups() {
  yield takeLatest(getProductGroups.type, handleGetProductGroups);
}

function* handleGetProducts(input) {
  try {
    const data = yield call(mobilePosService.getProducts, input.payload);
    yield put(setProducts(data));
  } catch (e) {
    console.log(e.message);
    yield put(setIsLoading(false));
  }
}

export function* watchGetProducts() {
  yield takeLatest(getProducts.type, handleGetProducts);
}

function* handleSavePreInvoice(action) {
  try {
    const data = yield call(PreInvoicesService.savePreInvoice, action.payload);

    yield put(setPreInvoices(data));

    yield put(clearCart());

    toast.success('Your Order successfully Placed.');
  } catch (e) {
    console.error(e);
    toast.error('Order placement failed. Cart is still saved.');
  }
}

export function* watchGetPreInvoices() {
  yield takeLatest(savePreInvoiceRequest.type, handleSavePreInvoice);
}

function* handleForGetMyOrders(action) {
  try {
    const response = yield call(
      PreInvoicesService.getAllOrders,
      action.payload
    );
    yield put(setMyOrders(response.data.result));
  } catch (e) {
    console.error(e);
  }
}

export function* watchGetMyOrders() {
  yield takeLatest(getMyOrders.type, handleForGetMyOrders);
}

function* handleGetAllFavourites(action) {
  try {
    const response = yield call(
      [PreInvoicesService, PreInvoicesService.getAllFavourites],
      action.payload
    );
    const favorites = response.data.result?.items || [];
    yield put(setAllFavouriteProducts(favorites));
  } catch (e) {
    console.error('Fetch Favourites Error:', e.message);
  }
}

export function* watchGetAllFavourites() {
  yield takeLatest(getAllFavouriteRequest.type, handleGetAllFavourites);
}

function* handleToggleFavourite(action) {
  const { isDelete, id, productId, tenantId, userId } = action.payload;
  try {
    let response;
    if (isDelete) {
      response = yield call(
        [PreInvoicesService, PreInvoicesService.deleteFavourite],
        id
      );
    } else {
      const addPayload = {
        id: 0,
        tenantId,
        productId,
        userId,
        isFavourite: true,
      };
      response = yield call(
        [PreInvoicesService, PreInvoicesService.toggleFavourite],
        addPayload
      );
    }

    if (response && (response.status === 200 || response.data?.success)) {
      toast.success(
        isDelete ? 'Removed Favourite Product' : 'Added Favourite Product'
      );
      yield put(getAllFavouriteRequest({ userId, tenantId }));
    }
  } catch (e) {
    console.error('Toggle Error details:', e);
    toast.error('Operation failed');
  }
}

export function* watchToggleFavourite() {
  yield takeLatest(toggleFavouriteRequest.type, handleToggleFavourite);
}

function* handleSaveUserAddress(action) {
  try {
    const response = yield call(
      PreInvoicesService.saveUserAddress,
      action.payload
    );

    // Refresh the list after saving
    // yield put(getUserAddress({ userId: action.payload.userId }));

    toast.success('Address saved successfully!');
  } catch (e) {
    console.error('Save Error:', e);
    toast.error('Failed to save address');
  }
}

export function* watchSaveUserAddress() {
  yield takeLatest(saveUserAddress.type, handleSaveUserAddress);
}

// function* GetUserAddress(action) {
//   try {
//     // Payload ensure karein ke hamesha object ho
//     const payload = action.payload || {};
//     const response = yield call(PreInvoicesService.getUserAddress, payload);

//     // ABP Framework check: items ya direct result
//     const result = response.data?.result?.items || response.data?.result || [];
//     yield put(setUserAddressValue(result));
//   } catch (e) {
//     // BILKUL SAFE CHECK: Agar window.abp null hai to crash nahi hoga
//     let errorMsg = 'An unexpected error occurred';

//     if (window.abp && window.abp.localization) {
//       errorMsg = window.abp.localization.localize('AnUnexpectedErrorOccurred');
//     } else {
//       errorMsg = e.message || errorMsg;
//     }
//   }
// }

// export function* watchGetUserAddress() {
//   yield takeLatest(getUserAddress.type, GetUserAddress);
// }

export default function* rootSaga() {
  yield all([
    fork(watchGetProductGroups),
    fork(watchGetProductBanners),
    fork(watchGetProducts),
    fork(watchGetPreInvoices),
    fork(watchGetMyOrders),
    fork(watchGetAllFavourites),
    fork(watchToggleFavourite),
    fork(watchSaveUserAddress),
    // fork(watchGetUserAddress),
  ]);
}
